import { FC } from 'react';
import { TreeSelect, TreeSelectProps } from 'antd';

const ProTreeSelect: FC<TreeSelectProps> = (props) => {
  return <TreeSelect {...props} />
};

export default ProTreeSelect;
